import { io } from 'socket.io-client';

const URL = `${import.meta.env.VITE_WS_URL}/flows`;

export const socket = io(URL, { autoConnect: false });
